import * as R from 'ramda'
import { Box } from '@mui/material'
import { UserListItemSkeleton } from '$common/user-list-item'

const CHAT_LIST_ITEM_SKELETON_HEIGHT = 70
const CHAT_LIST_SEARCH_ITEM_SKELETON_HEIGHT = 56

type SkeletonSize = 'medium' | 'large'

export function FullPageListSkeleton({ size }: { size?: SkeletonSize }) {
  const ITEM_HEIGHT =
    size === 'medium'
      ? CHAT_LIST_SEARCH_ITEM_SKELETON_HEIGHT
      : CHAT_LIST_ITEM_SKELETON_HEIGHT
  const skeletonCount = Math.ceil(window.innerHeight / ITEM_HEIGHT)

  return (
    <Box sx={{ overflow: 'hidden', backgroundColor: 'white' }}>
      {R.times(
        i => (
          <UserListItemSkeleton key={i} size={size} />
        ),
        skeletonCount,
      )}
    </Box>
  )
}

FullPageListSkeleton.defaultProps = {
  size: 'medium',
}
